module.exports = __webpack_public_path__ + "static/media/OSHA-ANSI.85264ea6.svg";


//////////////////
// WEBPACK FOOTER
// ./src/wbstdt/imgs/products/OSHA-ANSI.svg
// module id = 82
// module chunks = 0